var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_829",
    "data-name": "Grupo 829",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.168 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_281",
    "data-name": "Rect\\xE1ngulo 281",
    width: 35.168,
    height: 40,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_476",
    "data-name": "Trazado 476",
    d: "M301.085,0a1.4,1.4,0,0,1,.876,1.525c-.04.635,0,1.275-.01,1.912a1.169,1.169,0,0,1-1.164,1.248,1.189,1.189,0,0,1-1.174-1.247c-.009-.65.02-1.3-.008-1.951A1.349,1.349,0,0,1,300.538,0Z",
    transform: "translate(-276.153)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_477",
    "data-name": "Trazado 477",
    d: "M18.695,42.644a3.891,3.891,0,0,1,1.58,3.242,4.605,4.605,0,0,1-1.886,3.134c.894.874,1.8,1.684,2.618,2.571a3.506,3.506,0,0,1-5.145,4.765q-2.6-2.588-5.189-5.191c-.164-.165-.3-.354-.492-.575-.3.311-.539.565-.786.808a3.5,3.5,0,0,1-5.122-.007q-1.582-1.565-3.147-3.147a3.494,3.494,0,0,1,.01-5.147c2.09-2.106,4.214-4.178,6.28-6.308A24.112,24.112,0,0,0,13.8,24.713a.752.752,0,0,0-.071-.47,3.527,3.527,0,0,1,.921-4.554,3.481,3.481,0,0,1,4.626.331q6.61,6.585,13.193,13.2a3.516,3.516,0,0,1-2.158,6.013,3.54,3.54,0,0,1-2.029-.437.825.825,0,0,0-.5-.075A24.149,24.149,0,0,0,19,42.419c-.085.057-.165.121-.3.224M15.779,26.562a26.856,26.856,0,0,1-5.625,10.714l5.08,5.077a26.848,26.848,0,0,1,10.712-5.627L15.779,26.562m-7.3,12.518c-.067.061-.136.119-.2.183Q5.543,42,2.812,44.729a1.2,1.2,0,0,0,.011,1.9q1.516,1.52,3.036,3.036a1.207,1.207,0,0,0,1.96-.01Q10.5,46.982,13.173,44.3c.091-.091.177-.187.252-.266L8.475,39.081m22.7-3.168a1.42,1.42,0,0,0-.494-1.174Q24.22,28.282,17.763,21.82a2.4,2.4,0,0,0-.285-.265,1.12,1.12,0,0,0-1.213-.12,1.107,1.107,0,0,0-.652.99,1.3,1.3,0,0,0,.47,1.026q6.491,6.484,12.976,12.974a2.04,2.04,0,0,0,.257.239,1.132,1.132,0,0,0,1.215.117,1.081,1.081,0,0,0,.649-.868M11.847,49.036l3.595,3.592c.717.717,1.428,1.44,2.154,2.149a1.166,1.166,0,0,0,1.971-.6,1.21,1.21,0,0,0-.412-1.154q-2.72-2.713-5.434-5.432c-.08-.08-.168-.151-.233-.209l-1.64,1.65M16.8,47.284c1.662-1.385,1.4-2.05-.015-3.19l-1.638,1.545L16.8,47.284",
    transform: "translate(0 -17.478)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_478",
    "data-name": "Trazado 478",
    d: "M364.357,31.142a3.654,3.654,0,0,1-.444.789c-.742.784-1.512,1.541-2.284,2.3a1.169,1.169,0,1,1-1.649-1.655q1.133-1.157,2.289-2.291a1.134,1.134,0,0,1,1.325-.263,1.346,1.346,0,0,1,.763,1.126",
    transform: "translate(-331.459 -27.567)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_479",
    "data-name": "Trazado 479",
    d: "M391.851,119.709c.391,0,.781-.008,1.171,0a1.169,1.169,0,1,1-.017,2.337c-.768.011-1.536.012-2.3,0a1.169,1.169,0,1,1,.017-2.338c.377-.009.755,0,1.132,0",
    transform: "translate(-359.031 -110.337)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_480",
    "data-name": "Trazado 480",
    d: "M75.005,324.145a1.193,1.193,0,0,1,1.185.66,1.068,1.068,0,0,1-.145,1.243c-.582.63-1.187,1.242-1.82,1.821a1.16,1.16,0,0,1-1.611-1.659c.568-.608,1.157-1.2,1.769-1.762a2.029,2.029,0,0,1,.622-.3",
    transform: "translate(-66.656 -298.775)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.62c1c67be17fa64de55060fc72e30e70.svg";
export { ForwardRef as ReactComponent };